import { getEffectiveParam } from '@/features/config';
import type { CoverageCategoryKey, CoverageFunnelStep, FunnelStep } from '../types';

export const OFFER_CONFIG_PARAM = {
  priority: 'priority_access',
  pharma: 'coverage_pharma',
  environment: 'coverage_environment',
  finance: 'coverage_finance',
} as const;

export const COVERAGE_CATEGORY_ORDER: CoverageCategoryKey[] = [
  'pharma',
  'environment',
  'finance',
];

export const FUNNEL_STEP_LABEL: Record<FunnelStep['kind'], string> = {
  priority: 'Priority',
  coverage: 'Settlements',
  register: 'Register',
  get_app: 'Get App',
};

function paramPlanId(key: string): string | null {
  const value = getEffectiveParam(key)?.trim();
  return value || null;
}

/**
 * Post-purchase funnel after checkout. Priority / Coverage appear only when
 * their plan ids are present in URL or funnel config. Register and Get App
 * always follow.
 */
export function resolveFunnelSteps(): FunnelStep[] {
  const steps: FunnelStep[] = [];

  const priorityPlanId = paramPlanId(OFFER_CONFIG_PARAM.priority);
  if (priorityPlanId) {
    steps.push({ kind: 'priority', planId: priorityPlanId });
  }

  const coveragePlanIds: CoverageFunnelStep['planIds'] = {};
  for (const key of COVERAGE_CATEGORY_ORDER) {
    const planId = paramPlanId(OFFER_CONFIG_PARAM[key]);
    if (planId) coveragePlanIds[key] = planId;
  }
  if (Object.keys(coveragePlanIds).length > 0) {
    steps.push({ kind: 'coverage', planIds: coveragePlanIds });
  }

  steps.push({ kind: 'register' });
  steps.push({ kind: 'get_app' });
  return steps;
}

export function funnelOfferLabels(steps: FunnelStep[]): string[] {
  return steps.map((step) => FUNNEL_STEP_LABEL[step.kind]);
}
